module.exports = __webpack_public_path__ + "img/home-no-data.5164966f.svg";